import {categorizeSpecialtiesByFirstLetter, sortByKey, Specialty} from 'presentation/utils';
import {GetExamsTypesLocationModel} from 'domain/usecases';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';

export function formatExamsList(list: GetExamsTypesLocationModel) {
	const examTypes = list?.tiposExames;

	if (!examTypes || examTypes.length === 0) {
		return [];
	}

	const parsedTypes: Specialty<FlowEnum.EXAM>[] = examTypes.map(type => ({
		code: type.cdTipoExame,
		description: type.dsTipoExame,
		formattedText: type.dsTipoExame,
		cdProcedimento: type.cdProcedimento,
		dsInformacaoComplementar: type.dsInfoComplementar,
		dsPreparo: type.dsPreparo,
		dtCarencia: type.dtCarencia,
		flAutorizacao: type.flAutorizacao,
		flCarencia: type.flCarencia,
		flPreparo: type.flPreparo,
		flLivreDemanda: type.flLivreDemanda,
	}));
	const sortedTypesByName = parsedTypes && sortByKey(parsedTypes, 'formattedText');
	const categorizedTypes =
		sortedTypesByName && categorizeSpecialtiesByFirstLetter(sortedTypesByName);

	return categorizedTypes;
}
